import Vuex from "vuex";
import basketStore from "./basket.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    basketStore
  }
});
